import React, { useState } from 'react';
import { ChevronsUpDown, ClipboardPlus, Eye } from "lucide-react";
import Badge from '../UI/Badge';
import { Link, useNavigate } from 'react-router-dom';
import { can_visit, exchangeDate, usPhoneFormat } from '../../helpers';

const styles = {
  display: "flex",
  alignItems: "center",
  gap: "5px",
  cursor: "pointer",
};

export default function AIChartingDataTable(props) {
  const {
    tableData = [],
    reloadData = () => {},
    reloadDataFilter = {},
    dataLoading,
    setDataLoading = () => {}
  } = props;

  const [orderBy, setOrderBy] = useState();
  const navigate = useNavigate();

  const handleOrderChange = (name, type = "asc") => {
    name = name.toString();
    setOrderBy(name);
    if (reloadDataFilter.order_by && reloadDataFilter.order_by[0] == name) {
      if (reloadDataFilter.order_by[1] == "asc") {
        type = "desc";
      }
    }
    const orderFilter = { order_by: [name, type.toString()] };
    const filter_merge = { ...reloadDataFilter, ...orderFilter };
    reloadData(filter_merge);
    setDataLoading(true);
  };

  return (
    <>
      <div className="docpro_table_responsive" style={{ minHeight: "250px" }}>
        <table className="docpro_mb_0">
          <thead>
            <tr>
              <th>
                <div
                  onClick={() => {
                    handleOrderChange("dos");
                  }}
                  className={
                    orderBy === "dos" ? "docpro_accent_color" : ""
                  }
                >
                  <div style={styles}>DOS <ChevronsUpDown size={"12"} />
                  </div>
                </div>
              </th>
              <th>Last Name</th>
              <th>First Name</th>
              <th>Date of Birth</th>
              <th>Gender</th>
              <th>Phone</th>
              <th>Visit Type</th>
              <th>Insurance Name</th>
              <th>
                <div
                  onClick={() => {
                    handleOrderChange("status");
                  }}
                  className={
                    orderBy === "status" ? "docpro_accent_color" : ""
                  }
                >
                  <div style={styles}>Status <ChevronsUpDown size={"12"} />
                  </div>
                </div>
              </th>
              {/* <th></th> */}
            </tr>
          </thead>
          <tbody>
            {!dataLoading ? (
              tableData && tableData.length > 0 ? (
                tableData?.map((item, index) => (
                  <tr 
                    key={index}
                    onClick={() => {
                      const url = item?.status !== "Done" 
                        ? can_visit('ai_charting_create') && (`/ai-charting/create?patient_id=${item?.patient_id}&chart_no=${item?.id}`)
                        : `/ai-charting/view?patient_id=${item?.patient_id}&chart_no=${item?.id}`;
                        navigate(url);
                    }}
                    style={{ cursor: 'pointer' }}
                  >
                    <td className='py-2'>
                      {item?.dos !== null ? exchangeDate(item?.dos) : ''}
                    </td>
                    <td className='py-2'>
                      {item?.last_name}
                    </td>
                    <td className='py-2'>
                      {item?.first_name}
                    </td>
                    <td className='py-2'>
                      {exchangeDate(item?.dob)}
                    </td>
                    <td className='py-2'>
                      {item?.sex === "M" ? "Male" : item?.sex === "F" ? "Female" : "Other"}
                    </td>
                    <td className='py-2'>
                      {item?.mobile_phone === null ? usPhoneFormat(item?.home_phone) : usPhoneFormat(item?.mobile_phone) || ""}
                    </td>
                    <td className='py-2'>
                      {item?.vt_name}
                    </td>
                    <td className='py-2'>
                      {item?.insurance_name}
                    </td>
                    <td className='py-2'>
                      {item?.status === "Done" ? (
                        <Badge color="green">Done</Badge>
                      ) : (
                        <Badge color="red">Pending</Badge>
                      )}
                    </td>
                    {/* <td>
                      <div className="docpro_icon_btns">
                        {item?.status !== "Done" ?
                          <Link to={`/ai-charting/create?patient_id=${item?.patient_id}&chart_no=${item?.id}`}>
                            <button type="button" className="docpro_icon_btn">
                              <ClipboardPlus width={20} height={20} />
                              <span className="docpro_tip">Create</span>
                            </button>
                          </Link>
                        :
                          <Link to={`/ai-charting/view?patient_id=${item?.patient_id}&chart_no=${item?.id}`}>
                            <button type="button" className="docpro_icon_btn">
                              <Eye width={20} height={20} />
                              <span className="docpro_tip">View</span>
                            </button>
                          </Link>
                        }
                      </div>
                    </td> */}
                  </tr>
                ))
              ) : (
                <tr>
                  <td className="no_data docpro_p_0" style={{ height: "250px" }} colSpan="10">
                    No data available
                  </td>
                </tr>
              )
            ) : (
              <tr>
                <td className="no_data docpro_p_0" style={{ height: "250px" }} colSpan="10">
                  Loading...
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </>
  );
}
